import { createSelector } from 'reselect'

export const getMonth = state => state.reportEmptyKilometers.get('month')
export const getData = state => state.reportEmptyKilometers.get('data')
export const getFetching = state => state.reportEmptyKilometers.get('fetching')

export const createGetDataSelector = () => createSelector([getData], data => data)
